import {TypeLocalNameEnum} from 'domain/usecases';
import {BookingDataState} from './types';

const BOOKING_DATA_DEFAULT: BookingDataState = {
	specialtyCode: '',
	specialtyName: '',
	procedureCode: '',
	unitCode: '',
	unitName: '',
	unitAddress: '',
	professionalCode: '',
	professionalName: '',
	dateAt: '',
	hourAt: '',
	phone: '',
	email: '',
	ufCode: '',
	ufName: '',
	cityName: '',
	typeLocalName: TypeLocalNameEnum.CIDADE,
	reference: '',
	districtName: '',
	subSpecialtyCode: '',
	isRebooking: false,
	bookingNumber: '',
	protocolNumber: '',
	odontoRecommendations: '',
	multipleBookings: false,
	allDistrictsSelected: false,
	citiesNames: '',
	coordinates: '',
	isManualLocation: true,
	hasGeoDistrictsFilter: false,
	hasTelehealth: undefined,
	odontoUnitDistrictSelected: '',
	shouldBackToSpecialtyStep: false,
	isFavoriteDoctorsFlow: false,
	isScheduleScript: false,
	isBookingByMedicalGuideFlow: false,
	isAdvanceDiagnosticsFlow: false,
	initialBookingLocationData: undefined,
};

export {BOOKING_DATA_DEFAULT};
